/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Errors } from '../prefabs/Errors';
import { getErrors } from '../utils/getErrorMessage';
import Vertical from '@cube3/ui/src/Layout/vertical';
import StyledPopper from '@cube3/ui/src/helpers//StyledPopper';
import Cube3TextField from '@cube3/ui/src/forms/textfields/Cube3TextField';

import { WrappedFieldInputProps, WrappedFieldMetaProps } from 'redux-form';
import { shouldShowErrors } from '../utils/shouldShowErrors';

export interface ExtendedFieldMetaProps extends WrappedFieldMetaProps {
  asyncValidated: boolean;
}

export type ShowErrorsOptions = boolean | 'touched' | 'intentTouched';
export interface GenericFieldWithErrorsProps
  extends WrappedFieldInputProps,
    ExtendedFieldMetaProps {
  showLabel?: boolean;
  label: string;
  type: string;
  placeholder?: string;
  autoComplete?: string;
  showAsyncValid: boolean;
  disabled: boolean;
  required?: boolean;
  /**
   * when to show validation errors
   * - true          : always show
   * - false         : never show
   * - 'touched'     : show if field is marked touched
   * - 'intentTouched: show if field is marked touched, but ignore intial touched state from autofocus
   */
  showErrors: ShowErrorsOptions;
  renderTip(props: GenericFieldWithErrorsProps): React.ReactElement;
  inputProps?: WrappedFieldInputProps;
  // select field contents when component mounts
  startSelected?: boolean;
  errorMessage?: string;
  patern?: boolean;
  multiline?: boolean;
  // focus field when component mounts
  autoFocus?: boolean;
  // number type
  numberControls?: JSX.Element;
  min?: number;
  max?: number;
  step?: number;
}

// eslint-disable-next-line
class GenericFieldWithErrors extends React.PureComponent<
  GenericFieldWithErrorsProps,
  { ref: React.RefObject<HTMLDivElement>; focus: boolean }
> {
  state = {
    focus: false,
    ref: React.createRef<HTMLDivElement>()
  };

  onInputRef = (node) => {
    if (node && this.props.startSelected) {
      node.select();
    }
  };

  ignoreTouch: boolean | null = null;
  componentDidUpdate(oldProps) {
    if (this.props.active && !oldProps.active) {
      if (this.ignoreTouch === null) {
        this.ignoreTouch = true;
      } else if (this.ignoreTouch === true) {
        this.ignoreTouch = false;
      }
    }
  }

  render() {
    const {
      showLabel = true,
      label,
      type,
      placeholder,
      autoComplete,
      autoFocus,
      showAsyncValid,
      disabled,
      renderTip,
      showErrors = 'touched',
      inputProps,
      errorMessage,
      multiline,
      numberControls,
      //meta
      error,
      touched,
      active,
      asyncValidating,
      asyncValidated,
      // input
      ...inputState
    } = this.props;

    const errors = getErrors(errorMessage, error);

    const shouldShow = shouldShowErrors(
      showErrors,
      touched,
      active,
      autoFocus,
      this.ignoreTouch
    );
    const shouldList = shouldShowErrors(
      showErrors,
      touched,
      false,
      autoFocus,
      this.ignoreTouch
    );

    const tip = renderTip && renderTip(this.props);

    return (
      <div ref={this.state.ref}>
        <Vertical>
          <Cube3TextField
            label={showLabel && label}
            error={errors && shouldShow}
            autoComplete={autoComplete}
            autoFocus={autoFocus}
            type={type}
            fullWidth={true}
            placeholder={placeholder || label}
            helperText={errors && shouldList && <Errors errors={errors} />}
            formHelperTextProps={{ error: !!errors }}
            disabled={disabled}
            {...inputState}
            {...inputProps}
            inputRef={this.onInputRef}
            multiline={multiline}
            rowsMin={multiline ? 3 : 1}
            numberControls={numberControls}
          />

          {/* {errors &&
              (touched && !active) && (
                <StyledPopper placement="left" open={true}>
                  <Errors errors={errors} />
                </StyledPopper>
              )} */}
          {asyncValidating && (
            <StyledPopper
              placement="left"
              anchorEl={this.state.ref.current}
              open={!!this.state.ref.current}
            >
              &#8987;
            </StyledPopper>
          )}

          {tip && (
            <StyledPopper
              placement="right"
              anchorEl={this.state.ref.current}
              open={!!this.state.ref.current}
            >
              {tip}
            </StyledPopper>
          )}
          {/* NOTE: this uses a redux-form plugin (see root reducer) */}
          {showAsyncValid && asyncValidated && !asyncValidating && !errors && (
            <StyledPopper
              placement="left"
              anchorEl={this.state.ref.current}
              open={!!this.state.ref.current}
            >
              &#10004;
            </StyledPopper>
          )}
        </Vertical>
      </div>
    );
  }
}

export default GenericFieldWithErrors;
